import { render, staticRenderFns } from "./HelpTooltipDialogRecentJobs.vue?vue&type=template&id=118b58e8&"
import script from "./HelpTooltipDialogRecentJobs.vue?vue&type=script&lang=ts&"
export * from "./HelpTooltipDialogRecentJobs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCardText,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('118b58e8')) {
      api.createRecord('118b58e8', component.options)
    } else {
      api.reload('118b58e8', component.options)
    }
    module.hot.accept("./HelpTooltipDialogRecentJobs.vue?vue&type=template&id=118b58e8&", function () {
      api.rerender('118b58e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tooltips/HelpTooltipDialogRecentJobs.vue"
export default component.exports